import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import { Modal as AntModal, Spin } from "antd";
import { toast } from "react-toastify";
import Modal from "react-modal";

const HarvestDetailsList = (props) => {
  const { addForm, update } = props;
  const [data, setData] = useState([]);
  const [itemsPerPage] = useState(10);

  const { sendRequest: getDataList } = useHttp();

  const [allData, setAllData] = useState([]);

  const { sendRequest: deleteHarvest } = useHttp();
  const [deleteLoading, setDeleteLoading] = useState(false);

  const deleteData = (e, vehicleWeighBridgeId) => {
    e.preventDefault();
    console.log(vehicleWeighBridgeId);

    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this harvest detail?",
      onOk() {
        const data = {
          vehicleWeighBridgeId: vehicleWeighBridgeId,
        };
        setDeleteLoading(true);

        deleteHarvest(
          {
            url: `/api/vehicleWeighBridge/`,
            method: "DELETE",
            body: data,
          },
          (res) => {
            console.log();

            if (res.success) {
              toast.success(res.success);
            }

            if (res.error) {
              toast.error(res.error);
            }
            setDeleteLoading(false);
            FillDetail();
          },
          (error) => {
            toast.error(error);
            setDeleteLoading(false);
          }
        );
      },
      onCancel() {
        setDeleteLoading(false);
      },
    });
  };

  const FillDetail = () => {
    getDataList(
      {
        url: `/api/vehicleWeighBridge/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          setData(res);
          setAllData(res);
        }
      }
    );
  };

  useEffect(() => {
    FillDetail();
  }, [getDataList]);

  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSearch = (e) => {
    var filetrtext = e.target.value.trim().toLowerCase();
    //console.log(filetrtext);

    var filterdata = allData.filter(
      (item) =>
        item?.employeeName?.includes(filetrtext) ||
        item?.vehicleCode?.includes(filetrtext)
    );

    setData(filterdata);

    setCurrentPage(1);
  };

  const { sendRequest: getDetailView } = useHttp();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (data) => {
    console.log(data);

    const vehicleWeighBridgeId = data && data.vehicleWeighBridgeId;

    getDetailView(
      {
        url: `/api/vehicleWeighBridge/?orgId=${localStorage.getItem(
          "orgId"
        )}&vehicleWeighBridgeId=${vehicleWeighBridgeId}`,
      },
      (res) => {
        console.log("Detail View", res);

        setSelectedData(res);
      }
    );

    //  setSelectedData(data);
    setIsModalOpen(true);
  };
  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
      top: 50,
      left: 30,
    },
    content: {
      top: "50%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "800px",
      minHeight: "500px",
      height: "80%",
      minHeight: "auto",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };
  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-2 my-3">
              {" "}
              &nbsp; &nbsp; Harvest Details{" "}
            </label>{" "}
          </div>
          <div className="col-3"> </div>
          <div className="col-3 text-right">
            <button
              type="button"
              className="btn  btn-primary mx-2 my-2"
              onClick={() => {
                addForm(true);
                props.update(false);
              }}
            >
              Add Harvest Details
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-9"> </div>

                      <div className="col-3">
                        {" "}
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                          placeholder="Search..."
                        />{" "}
                        <br />
                      </div>
                    </div>
                    <div className="row table-responsive">
                      <table className="table table-bordered text-center">
                        <thead>
                          <tr>
                            <th>Harvest Date</th>
                            <th>Doc No</th>
                            <th>Executive Name</th>
                            <th>Harvest Officer</th>
                            <th>Vehicle No</th>
                            <th>Trip Id</th>
                            <th>Average Empty Crates Weight(Kg)</th>
                            <th>Loaded Vehicle Weight(Ton)</th>
                            <th>Empty Vehicle Weight(Ton)</th>
                            <th>View</th>
                            <th>Edit</th>
                            <th>Delete</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems &&
                            currentItems.map((x, i) => (
                              <tr key={i}>
                                <td>{x.harvstDate}</td>
                                <td>{x.docNo}</td>
                                <td>{x.employeeName}</td>
                                <td>{x.harvestOfficer}</td>
                                <td>{x.vehicleCode}</td>
                                <td>{x.tripId}</td>
                                <td>
                                  {x.averageEmptyCratesWeightInKg || "NA"}
                                </td>
                                <td>{x.loadedVehicleWeightTons || "NA"}</td>
                                <td>{x.emptyVehicleWeightTons || "NA"}</td>
                                <td>
                                  <button
                                    className="btn"
                                    onClick={() => openModal(x)}
                                  >
                                    <i className="fas fa-eye"></i>
                                  </button>
                                </td>{" "}
                                <td>
                                  <button
                                    className="btn"
                                    onClick={() => {
                                      props.update({ ...x });
                                      props.addForm(true);

                                    }}
                                  >
                                    {" "}
                                    <i className="fas fa-edit"></i>
                                  </button>
                                </td>
                                <td>
                                  {
                                    deleteLoading === x ?
                                      (
                                        <Spin />
                                      ) : (
                                        <button
                                          onClick={(e) =>
                                            deleteData(e, x.vehicleWeighBridgeId)
                                          }
                                          className="btn"
                                        >
                                          <i className="fa fa-trash"></i>
                                        </button>
                                      )}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        <div className="">
          <h3 className="card-title">Farmer Harvest Details</h3>
          <div className="card-tools text-right">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={() => setIsModalOpen(false)}
            >
              <i className="fas fa-times" />
            </button>
            <hr />
          </div>
        </div>

        {selectedData && (
          <div className="mx-3">
            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Doc No: {selectedData.docNo}
              </p>
              <p className="col-md-6">
                Harvest Date : {selectedData.harvstDate}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Field Executive Name : {selectedData.employeeName}
              </p>
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Harvest Officer : {selectedData.harvestOfficer}
                { }
              </p>
            </div>

            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Trip Id: {selectedData.tripId}
              </p>
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Vehicle Name : {selectedData.vmeModelName}
                { }
              </p>
            </div>

            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Loaded Vehicle Weight(Tons):{" "}
                {selectedData.loadedVehicleWeightTons || "NA"}
              </p>
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Empty Vehicle Weight(Tons):{" "}
                {selectedData.emptyVehicleWeightTons || "NA"}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Average Empty Crate Weight(Tons):{" "}
                {selectedData.averageEmptyCratesWeightInKg || "NA"}
              </p>
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Season Name :{" "}
                {selectedData?.farmerHarvestDetail?.[0]?.seasonName || "NA"}
              </p>
            </div>
            <h3 className="text-lg font-medium mt-6">Farmer Harvest Details</h3>

            <table className="table table-bordered mt-3 table-responsive">
              <thead>
                <tr className="table-header text-center">
                  <th rowSpan="2">#</th>
                  <th rowSpan="2">Farmer</th>
                  <th rowSpan="2">Plot</th>
                  <th rowSpan="2">Crop</th>
                  <th rowSpan="2">Variety</th>
                  <th rowSpan="2">Harvest ID</th>
                  <th rowSpan="2">Specific Field Pick</th>
                  <th rowSpan="2">Fruit/Grain Quality</th>
                  <th rowSpan="2">Crates/Bags Qty Loaded</th>
                  <th rowSpan="2">Average Weight of Crate/Bags (kg)</th>
                  <th rowSpan="2">Extra Crates/Bags (kg)</th>
                  <th rowSpan="2">Total Quantity (kg)</th>

                  {/* Conditionally show Farmer Share group */}
                  {selectedData?.farmerHarvestDetail?.some((row) =>
                    ["maize", "soyabean"].includes(row.cropName?.toLowerCase())
                  ) && <th colSpan="4">Farmer Share</th>}

                  <th rowSpan="2">Grand Total</th>
                </tr>

                {/* Subheader row for Farmer Share */}
                {selectedData?.farmerHarvestDetail?.some((row) =>
                  ["maize", "soyabean"].includes(row.cropName?.toLowerCase())
                ) && (
                    <tr className="text-center">
                      <th>Crates/Bags Qty Loaded</th>
                      <th>Avg Weight (kg)</th>
                      <th>Extra Qty (kg)</th>
                      <th>Total Qty (kg)</th>
                    </tr>
                  )}
              </thead>

              <tbody>
                {selectedData?.farmerHarvestDetail?.map((row, i) => (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td>{row.farmerName}</td>
                    <td>{row.plotName || row.plotCode}</td>
                    <td>{row.cropName}</td>
                    <td>{row.varietyName}</td>
                    <td>{row.harvestId}</td>
                    <td>{row.specificFieldPickId}</td>
                    <td>{row.fruitQuality}</td>

                    {/* Main Quantity */}
                    <td>{row.cratesBagQtyLoaded || "NA"}</td>
                    <td>{row.averageWeightOfCratesInKg || "NA"}</td>
                    <td>{row.extraQty || "NA"}</td>
                    <td>{row.totalQuantity}</td>

                    {/* Conditionally show Farmer Share */}
                    {["maize", "soyabean"].includes(
                      row.cropName?.toLowerCase()
                    ) && (
                        <>
                          <td>{row.farmerShareCratesBagQtyLoaded}</td>
                          <td>{row.farmerShareAverageWeightOfCratesInKg}</td>
                          <td>{row.farmerShareExtraQty || "NA"}</td>
                          <td>{row.farmerShareTotalQuantity}</td>
                        </>
                      )}

                    <td>{row.grandTotal}</td>
                  </tr>
                ))}
              </tbody>
            </table>

            {selectedData.fileAttachment &&
              selectedData.fileAttachment.length > 0 && (
                <>
                  <h3 className="text-lg font-medium mt-6">File Attachments</h3>
                  <div className="row">
                    {selectedData.fileAttachment.map((file, idx) => {
                      const fileUrl = `${process.env.REACT_APP_FILE_URL}${file.urlAttachments}`;
                      return (
                        <div className="col-md-4 mb-3" key={idx}>
                          <div className="card shadow-sm p-2 text-center">
                            <img
                              src={fileUrl}
                              // alt={file.fileName}
                              style={{
                                width: "100%",
                                height: "120px",
                                objectFit: "cover",
                                borderRadius: "8px",
                              }}
                            />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </>
              )}
          </div>
        )}
      </Modal>
    </>
  );
};

export default HarvestDetailsList;
